<header class="top-header">
  <nav class="container mx-auto px-4 py-3 flex items-center justify-center lg:justify-between ">
    <!-- Logo -->
    <div class="flex items-center">
      <a href="/" class="flex items-center w-[200px] md:w-[200px]">
        <img src="/logo.png" alt="Apne Rishte Logo" class="w-auto ">
      </a>
    </div>

    <!-- Desktop Navigation -->
    <div class="hidden lg:flex items-center space-x-8 header-menu">
      <a [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active" routerLink="/" class="">Home</a>

      @if (authService.isLoggedIn()) {
        <a routerLinkActive="active" routerLink="/suggestions">Search Partner</a>
      } @else {
        <a routerLinkActive="active" routerLink="/suggestions/brides">Find Bride</a>
        <a routerLinkActive="active" routerLink="/suggestions/grooms">Find Groom</a>
      }
      @if (authService.isLoggedIn()) {
        <a routerLinkActive="active" routerLink="/dashboard/saved-users" class="flex items-center gap-1">Shortlisted
          @if (badges().saved > 0) {
            <span class="bg-green-500 text-white px-2 rounded-full text-xs">{{ badges().saved }}</span>
          }
        </a>
        <a routerLinkActive="active" routerLink="/dashboard/messages">Messages
          @if (badges().messages > 0) {
            <span class="bg-red-500 text-white px-2 rounded-full text-xs">{{ badges().messages }}</span>
          }</a>
        <!--        <a routerLinkActive="active" routerLink="/dashboard/matches">Matches-->
          <!--          @if (authService.isLoggedIn() && badges().match_count > 0) {-->
          <!--            <span class="bg-red-500 text-white px-2 rounded-full text-xs">{{ badges().match_count }}</span>-->
          <!--          }</a>-->
          <!--        <a routerLinkActive="active" routerLink="/dashboard/incoming-requests">Requests-->
          <!--          @if (authService.isLoggedIn() && badges().likes > 0) {-->
          <!--            <span class="bg-red-500 text-white px-2 rounded-full text-xs">{{ badges().likes }}</span>-->
          <!--          }</a>-->
        <div class="flex ">
          <app-resized-image class="overflow-hidden" [src]="authService.user()?.avatar" [width]="42" [height]="42"/>
          <a routerLink="/dashboard/incoming-requests" class="flex flex-col max-w-[150px] px-2 py-1 bg-gray-100">
            <div class="line-clamp-1">{{ authService.user()?.name }}</div>
            <small class="text-xs text-gray-400">DASHBOARD</small>
          </a>

        </div>
      } @else {
        <a routerLink="/login" class=" px-4 py-3 text-center text-white bg-primary rounded-md hover:bg-primary/80 center-all gap-2">
          <i class="fa-thin fa-lock"></i>
          <span>Login / Register</span>
        </a>
      }</div>

    <!-- Mobile menu button -->
    <div class="md:hidden">
      @if (!authService.isLoggedIn()) {
        <a routerLink="/login" class="text-sm btn-base bg-primary text-white">LOGIN/REGISTER</a>
      }
    </div>
  </nav>


</header>

<div class="mobile-nav">
  <!--  <a routerLinkActive="active" pRipple routerLink="/dashboard/incoming-requests"><i class="fa-light fa-heart"></i><span class="label">REQUESTS</span>-->
  <!--    <app-counter-badge [value]="badges().likes"></app-counter-badge>-->
  <!--  </a>-->
  <!--  <a routerLinkActive="active" routerLink="/dashboard/matches"><i class="fa-light fa-users"></i><span class="label">MATCHES</span>-->
  <!--    <app-counter-badge [value]="badges().match_count"></app-counter-badge>-->
  <!--  </a>-->
  <a routerLinkActive="active" routerLink="/suggestions"><i class="fa-light fa-home"></i><span class="label">HOME</span></a>
  <a routerLinkActive="active" routerLink="/dashboard/saved-users"><i class="fa-light fa-star"></i>
    <span class="label">SAVED</span></a>
  <a routerLinkActive="active" routerLink="/dashboard/messages"><i class="fa-light fa-message"></i>
    <app-counter-badge [value]="badges().messages"></app-counter-badge>
    <span class="label">CHAT</span></a>

</div>


